import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import GridPhotos from 'components/common/GridPhotos';
import OrderDone from 'assets/images/order_done.png';
import { Button, Col, Row, Typography } from 'antd';
import { imageUploadHandler } from 'utils/tools';
import { Editor } from '@tinymce/tinymce-react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderHistoriesSelectors } from 'redux/orders/selectors';

import {
  forceFeedback,
  getByIdOrders,
  getOrderHistory,
} from 'redux/orders/actions';

const DoneStatus = ({ onCancel, order, item }) => {
  const dispatch = useDispatch();
  const [note, setNote] = useState('');
  const [isReject, setReject] = useState(false);
  const orderHistories = useSelector(getOrderHistoriesSelectors);
  const isLast = orderHistories[orderHistories.length - 1]?.id === item?.id;

  const reject = () => {
    setReject(true);
  };

  const confirmReject = useCallback(() => {
    dispatch(
      forceFeedback({
        id: item.id,
        data: {
          feedback: note,
        },
      }),
    ).then(({ payload }) => {
      if (payload?.id) {
        dispatch(getOrderHistory(order?.backupId));
        dispatch(getByIdOrders({ data: order }));
        onCancel();
        setNote('');
      }
    });
    // eslint-disable-next-line
  }, [item, note]);

  if (isReject) {
    return (
      <div>
        {isLast && (
          <Typography.Title level={3}>
            {i18next.t(`orders.rejectOrderStatus.${item.status}`)}
          </Typography.Title>
        )}
        <div
          className="html-content"
          dangerouslySetInnerHTML={{ __html: item.note }}
        />
        <GridPhotos images={order?.products?.[0]?.productImages || []} />
        <br />
        <Editor
          // bounds=".app"
          // modules={modules}
          toolbar="undo redo | forecolor backcolor | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link media image"
          init={{
            height: '400',
            images_upload_handler: imageUploadHandler,
          }}
          plugins="code link checklist autolink image imagetools media"
          onEditorChange={(text) => {
            setNote(text);
          }}
        />
        <br />
        <br />
        {isLast ? (
          <div>
            <Button onClick={confirmReject} type="primary">
              {i18next.t('button.reOpen')}
            </Button>
            &nbsp;&nbsp;
            <Button onClick={() => setReject(false)}>
              {i18next.t('button.cancel')}
            </Button>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <Row gutter={16}>
      <Col md={12}>
        <div>
          <Typography.Title level={3}>
            {i18next.t(`orders.orderStatus.${item.status}`)}
          </Typography.Title>
          <b>
            <a
              target="_blank"
              href={order.linkCustomer}
              rel="noopener noreferrer"
            >
              Order product Link
            </a>
          </b>
          <div
            className="html-content"
            dangerouslySetInnerHTML={{ __html: item.note }}
          />
          <img className="orderStatusImage" src={OrderDone} alt="" />
        </div>
      </Col>
      <Col md={12}>
        <GridPhotos images={order?.products?.[0]?.productImages || []} />
      </Col>
      <Col md={24}>
        {isLast ? (
          <Button type="primary" onClick={reject}>
            {i18next.t('button.reOpen')}
          </Button>
        ) : null}
      </Col>
    </Row>
  );
};

DoneStatus.propTypes = {
  order: PropTypes.object,
  item: PropTypes.object,
  onCancel: PropTypes.func,
};

export default DoneStatus;
